'use client'
import Footer from '@/components/Footer/FooterHome'
import { useState, useEffect } from 'react'

import {
  HeroHome,
  Testimonials,
  NutritionistTime,
  PlansCompare,
  Partners,
  Faq,
  Lapa
} from '@/sections'

import Cases from '@/sections/Cases'
import Influencers from '@/sections/InfluencersNew'
import TypesTraining from '@/sections/TypesTrainingNew'

import { Header, Modal, ButtonFixed, FormSoftlead, If } from '@/components'

import styles from './styles.module.scss'

export default function Home() {
  const [openModal, setOpenModal] = useState(false)
  const [productId, setProductId] = useState('play')
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) return <></>

  return (
    <>
      <Header hasLogin />
      <main className={styles.home}>
        <HeroHome />
        <Cases />
        <Testimonials />
        <Influencers />
        <TypesTraining />
        <NutritionistTime />
        <Lapa />
        <PlansCompare
          onPlanSelected={setProductId}
          setOpenModal={setOpenModal}
        />
        <Partners />
        <Faq />
        <ButtonFixed
          buttonId={'lp-button-fixed'}
          label={'QUERO EXPERIMENTAR'}
          elementIdStart={'cases'}
          elementIdToGo={'comparePlans'}
          elementIdEnd={'comparePlans'}
        />
        {openModal && (
          <div className={styles.modal}>
            <Modal
              isOpened={openModal}
              onCloseClick={() => setOpenModal(false)}
              variant={'center'}
              hasFooterButton={false}
            >
              <FormSoftlead className={styles.form} productId={productId} />
            </Modal>
          </div>
        )}
      </main>
      <Footer />
    </>
  )
}
